// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import MenuUnfold2OutlinedSvg from "@fishx/icons-svg/es/asn/MenuUnfold2Outlined";
import FishxIcon from '../components/FishxIcon';

var MenuUnfold2Outlined = function MenuUnfold2Outlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: MenuUnfold2OutlinedSvg
  }));
};

MenuUnfold2Outlined.displayName = 'MenuUnfold2Outlined';
export default React.forwardRef(MenuUnfold2Outlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/MenuUnfold2Outlined.js
// module id = 3115
// module chunks = 0